export enum ClientTag {
    MOBILE_CLIENT = 'MOBILE_CLIENT',
    INTERNET_CLIENT = 'INTERNET_CLIENT'
}
